// privacy.js

const privacyData = {
  title: "Privacy Policy",
  description:
    "Your trust is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our property listing and real estate services across Tamil Nadu.",

  sections: [
    {
      id: 1,
      title: "1. Privacy Policy",
      content:
        "Your trust is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our property listing and real estate services across Tamil Nadu.",
    },
    {
      id: 2,
      title: "2. Information We Collect",
      content: [
        "Your name, mobile number, and email address",
        "Your property needs (location, budget, type of property)",
        "Uploaded documents or property images",
        "Inquiry or chat messages",
        "IP address, device information, and browser type",
      ],
    },
    {
      id: 3,
      title: "3. How We Use Your Information",
      content: [
        "Help you find or sell properties",
        "Provide updates about listings and offers",
        "Share relevant alerts",
        "Respond to your queries",
        "Improve user experience",
        "Ensure platform security",
      ],
    },
    {
      id: 4,
      title: "4. What Makes Our Process Unique",
      content: [
        "We never misuse your data",
        "Documents shared only with verified buyers",
        "Region-specific matching (Tamil Nadu focus)",
      ],
    },
    {
      id: 5,
      title: "5. Sharing Your Information",
      content: [
        "With certified agents/builders",
        "With loan partners (only if requested)",
        "We never sell your data",
      ],
    },
    {
      id: 6,
      title: "6. Use of Browser Cookies",
      content: [
        "Remember preferences",
        "Understand behavior",
        "Show relevant listings",
        "You can disable cookies anytime",
      ],
    },
    {
      id: 7,
      title: "7. Your Rights",
      content: [
        "View your data",
        "Update your data",
        "Delete your data",
        "Unsubscribe anytime",
      ],
    },
    {
      id: 8,
      title: "8. Children's Privacy",
      content:
        "We do not collect data from children under 13. If found, it is deleted immediately.",
    },
    {
      id: 9,
      title: "9. Policy Updates",
      content:
        "We may update this policy anytime. Please check periodically.",
    },
    {
      id: 10,
      title: "10. Third-Party Websites",
      content:
        "We are not responsible for external websites like banks or government portals.",
    },
    {
      id: 11,
      title: "11. Contact Us",
      content: [
        "Mobile: +91 9500090493",
        "Address: Properties In Finite, Madurai, Tamil Nadu",
        "Email: propertiesinfiniteinfo@gmail.com",
      ],
      
    },
  ],
};

export default privacyData;